import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';

class ProductSku extends HTMLElement {
  #unsubscribeVariantChange;

  connectedCallback() {
    this.#unsubscribeVariantChange = PubSub.subscribe(
      'variant:change',
      ({ id, data: { html } }) => {
        id === this.dataset.productId && this.#handleSkuChange(html);
      }
    );
  }

  disconnectedCallback() {
    this.#unsubscribeVariantChange();
  }

  /**
   * Handle SKU change.
   * @param {Document} html - The parsed section HTML.
   */
  #handleSkuChange(html) {
    const productSku = html.querySelector('product-sku');
    if (!productSku) return;
    this.innerHTML = productSku.innerHTML;
  }
}

customElements.define('product-sku', ProductSku);
